<header *ngIf="hasRole('cde')" class="flex justify-between md:justify-end items-center mb-2">
  <a class="md:hidden" href="#">
    <div class="logo">
      <img src="assets/logo.svg" alt="Logo">
    </div>
  </a>

  <ul class="topbar-menu">
    <li>
      <a href="#" title="Notificaciones">
        <img src="assets/icons/notification-bell.png" alt="">
      </a>
    </li>
    <li>
      <a href="#" title="Mi Perfil">
        <img src="assets/icons/user-icon.png" alt="">
      </a>
    </li>
    <li class="md:hidden">
      <button (click)="toggleMobileMenu()">
        <i class="fa-solid fa-bars text-primary-700 text-4xl"></i>
      </button>
    </li>
  </ul>
  
  <div class="mobile-menu" [class.active]="isMobileMenuExpanded">
    <div class="flex justify-end pr-5">
      <button class="button-close" (click)="toggleMobileMenu()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <nav>
      <ul>
        <li>
          <a routerLink="/dashboards/home" routerLinkActive="active">
            Dashboard
          </a>
        </li>
        <li>
          <button class="dropdown" [class.active]="isMobileChartsExpanded" (click)="toggleMobileCharts()">
            Gráficos y Estadísticas
          </button>
          <ul *ngIf="isMobileChartsExpanded">
            <li>
              <a routerLink="/customer-report-home" routerLinkActive="active">Informes para clientes</a>
            </li>
            <!-- <li>
              <a routerLink="/daily-maintenance-report" routerLinkActive="active">Mantenciones diarias</a>
            </li>
            <li>
              <a routerLink="/future-maintenance-report" routerLinkActive="active">Futuras Mantenciones</a>
            </li>
            <li>
              <a routerLink="/container-in-customer-report" routerLinkActive="active">Envases en cliente</a>
            </li>
            <li>
              <a routerLink="/ph-state-report" routerLinkActive="active">Estado de PH</a>
            </li> -->
          </ul>
        </li>
        <!-- <li>
          <a routerLink="/quick-actions" routerLinkActive="active">
            Acciones rápidas
          </a>
        </li> -->
        <!-- <li>
          <button class="dropdown" [class.active]="isMobileContainerExpanded" (click)="toggleMobileContainer()">
            Envases
          </button>
          <ul *ngIf="isMobileContainerExpanded">
            <li>
              <a routerLink="/cylinder-report-home" routerLinkActive="active">Cilindros</a>
            </li>
            <li>
              <a routerLink="/container-report-home" routerLinkActive="active">Contenedores</a>
            </li>
            <li>
              <a routerLink="/isotank-report-home" routerLinkActive="active">Isotank</a>
            </li>
          </ul>
        </li> -->
        <li>
          <button class="dropdown" [class.active]="isMobileMantenedoresExpanded" (click)="toggleMobileMantenedores()">
            Mantenedores
          </button>
          <ul *ngIf="isMobileMantenedoresExpanded">
            <li>
              <a routerLink="/clients" routerLinkActive="active">Clientes</a>
            </li>
            <li>
              <a routerLink="/maintenance-types" routerLinkActive="active">Tipo Mantención</a>
            </li>
            <li>
              <a routerLink="/containers" routerLinkActive="active">Envase</a>
            </li>
            <li>
              <a routerLink="/container-types" routerLinkActive="active">Tipo de Envase</a>
            </li>
            <li>
              <a routerLink="/acceptance-criteria" routerLinkActive="active">Criterios</a>
            </li>
            <li>
              <a routerLink="/tasks" routerLinkActive="active">Tareas</a>
            </li>
            <li>
              <a routerLink="/maintenances" routerLinkActive="active">Mantenciones</a>
            </li>
          </ul>
        </li>
        <li>
          <a routerLink="/users" routerLinkActive="active">
            <span>Usuarios</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>


<header class="header-novedades" *ngIf="canAccess('dcs') || canAccess('mis-novedades') || canAccess('cloruro-ferrico') || canAccess('salmuera-i') || canAccess('salmuera-ii') || canAccess('comprension') || canAccess('electrolizadores') || canAccess('subestacion') || canAccess('mov-prod')">
  <form>
    <input class="input input-sm" 
           type="search" 
           placeholder="Buscar..." 
           (click)="openSearchModal()" 
           readonly />
  </form>
  <div class="user-date">
    <div class="user-data">
      <div class="content">
        <h5>{{ currentUser?.username || 'Usuario' }}</h5>
        {{ userRoleText }}
      </div>
      <a href="#" title="Mi Perfil">
        <img src="assets/icons/user-icon.png" alt="">
      </a>
    </div>
    <div class="date">
      <div class="day">{{ currentDay }}</div>
      <div class="month">{{ currentMonth }}</div>
      <div class="year">{{ currentYear }}</div>
    </div>
  </div>
</header>